<template>
  <div class="prize-draw-results  mb-3">
    <b-button
        class="w-100"
        variant="success"
        @click="dialog = true"
        >
      We are pleased to announce the winners for the February PrizeSaver draw! ... [Read More]
    </b-button>
    <b-modal
        title="February PrizeSaver Draw"
        size="md"
        v-model="dialog"
        ok-title="Close"
        ok-only
        ok-variant="success"
    >
      <b-table
          dark
          striped
          head-row-variant="success"
          thead-class="text-light"
          table-variant="light"
          table-class="text-dark"
          bordered
          small
          :items="prizeDrawResults"
          :fields="[
            { key: 'creditUnion', label: 'Credit Union' },
            { key: 'prize', label: 'Prize' }
          ]"
          />
      <p class="mb-0">Unfortunately, nobody from Cash Box has won this month – Good luck for our March draw!!</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "PriceDrawResults",
  computed: {
    prizeDrawResults() {
      // order by prize and then by credit union
      let results = this.results;
      return results.sort((a, b) => {
        if (a.prize === b.prize) {
          return a.creditUnion.localeCompare(b.creditUnion);
        }
        return b.prize - a.prize;
      });
    }
  },
  data() {
    return {
      dialog: false,
      results: [
        {
          creditUnion: "First Rate Credit Union",
          prize: 5000
        },
        {
          creditUnion: "London Capital Credit Union",
          prize: 50
        },
        {
          creditUnion: "Commsave Credit Union",
          prize: 50
        },
        {
          creditUnion: "Commsave Credit Union",
          prize: 50
        },
        {
          creditUnion: "Serve and Protect Credit Union",
          prize: 50
        },
        {
          creditUnion: "Clockwise Credit Union",
          prize: 50
        },
        {
          creditUnion: "South Manchester Credit Union",
          prize: 50
        },
        {
          creditUnion: "Commsave Credit Union",
          prize: 50
        },
        {
          creditUnion: "Serve and Protect Credit Union",
          prize: 50
        },
        {
          creditUnion: "London Capital Credit Union",
          prize: 50
        },
        {
          creditUnion: "Commsave Credit Union",
          prize: 50
        },
        {
          creditUnion: "Serve and Protect Credit Union",
          prize: 20
        },
        {
          creditUnion: "Commsave Credit Union",
          prize: 20
        },
        {
          creditUnion: "Planesaver Credit Union",
          prize: 20
        },
        {
          creditUnion: "Commsave Credit Union",
          prize: 20
        },
        {
          creditUnion: "Penny Post Credit Union",
          prize: 20
        },
        {
          creditUnion: "Transave Credit Union",
          prize: 20
        },
        {
          creditUnion: "Commsave Credit Union",
          prize: 20
        },
        {
          creditUnion: "South Manchester Credit Union",
          prize: 20
        },
        {
          creditUnion: "First Rate Credit Union",
          prize: 20
        },
        {
          creditUnion: "Commsave Credit Union",
          prize: 20
        }
      ]
    };
  }
}
</script>

<style>

</style>